import { 
  TopNavigation,
} from "@cloudscape-design/components";

import { navlinks } from "../data/navlinks";

export default () => {
    return (
        <TopNavigation data-class="top-nav-bar"
      identity={{
        href: "https://www.neptunedemos.com/",
        title: "Amazon Neptune Demos Hub",
        logo: {
          src: "neptune.png",
          alt: "Amazon Neptune Demos Hub"
        }
      }}
      utilities={navlinks}
      sticky={true}></TopNavigation>
    )
}